var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.94 11.06l-7.07 7.07M6.633 13L3.17 12.18a.5.5 0 01-.239-.84l2.754-2.754a1 1 0 01.7-.293l3.104-.027M13.4 4.714a22.415 22.415 0 015.886 5.886M11 17.367l.818 3.463a.5.5 0 00.84.24l2.754-2.755a1 1 0 00.293-.699l.027-3.105m4.147-5.536l.808-3.888a1.5 1.5 0 00-1.774-1.774l-3.888.808a5.993 5.993 0 00-3.02 1.632l-3.19 3.19a8.006 8.006 0 00-2.26 4.497l-.01.073a3.476 3.476 0 003.943 3.942l.072-.01a8 8 0 004.498-2.26l3.19-3.189a5.993 5.993 0 001.631-3.02z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRocket;